/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from "react";
import "./initiateChat.css";
import AdminTabs from "../adminTabs";
import { handleChefChat } from "../ChefVerification/services";
import { ThreeCircles } from "react-loader-spinner";

const InitiateChat = () => {
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [chatReason, setChatReason] = useState("");
  const [target, setTarget] = useState("");

  const handleUserName = (e) => {
    setUserName(e.target.value);
  };

  const handleUserMobile = (e) => {
    setUserMobile(e.target.value);
  };

  const handleChefChatReason = (e) => {
    setChatReason(e.target.value);
  };

  const handleTargetChange = (e) => {
    setTarget(e.target.value);
  };

  const handleCraverChat = () => {
  const confirmed = window.confirm("Are you sure you want to send this chat message?");
  if (!confirmed) return;

  setLoading(true);
  const dataToPost = {
    destination: userMobile,
    agent: target.toUpperCase(),
    params: JSON.stringify([userName, chatReason]),
  };

  setUserName("")
  setUserMobile("")
  setChatReason("");
  setTarget("");

  handleChefChat(dataToPost, setLoading);
};


  return (
    <div>
      <AdminTabs >
        <div className="chat">
            {loading && (
                    <div className="spinnerContainer">
                      <div className="spinner">
                        <ThreeCircles
                          color="blue"
                          height={110}
                          width={110}
                          ariaLabel="three-circles-rotating"
                        />
                      </div>
                    </div>
                  )}
          <h1>Initiate Gupshup chat with customer</h1>

          <div className="form-group">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">
                Name
              </span>
              <input
                type="text"
                class="form-control"
                placeholder="name"
                value={userName}
                onChange={handleUserName}
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon2">
                Number
              </span>
              <input
                type="text"
                class="form-control"
                value={userMobile}
                onChange={handleUserMobile}
                maxLength={10}
                placeholder="number"
                aria-label="Username"
                aria-describedby="basic-addon2"
              />
            </div>
            <label htmlFor="chefChat">Reason to chat</label>
            <textarea
              id="chefChat"
              className="form-control"
              rows="4"
              value={chatReason}
              onChange={handleChefChatReason}
              placeholder="Enter chef chat reason..."
            ></textarea>
          </div>
          <div className="form-group mb-3">
            <label htmlFor="chatTarget">Target</label>
            <select
              id="chatTarget"
              className="form-control"
              value={target}
              onChange={handleTargetChange}
            >
              <option value="" disabled>
                Select target
              </option>
              <option value="Supply">Supply</option>
              <option value="Support">Support</option>
            </select>
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              handleCraverChat();
            }}
          >
            Send Chat message
          </button>
        </div>
        </AdminTabs>
    </div>
  );
};

export default InitiateChat;
